const paths = {
  mail: "M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm0 0 9 7 9-7",
  phone:
    "M4.5 3h3.6a1 1 0 0 1 .97.76l.9 3.6a1 1 0 0 1-.27.98L7.6 10.5a13 13 0 0 0 5.9 5.9l2.16-2.13a1 1 0 0 1 .98-.27l3.6.9a1 1 0 0 1 .76.97v3.6a1 1 0 0 1-1 1C10.5 20.47 3.53 13.5 3.5 4.5v-.5a1 1 0 0 1 1-1Z",
  linkedin:
    "M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 9.5h4v11H3v-11Zm7 0h3.8v1.5h.05c.53-.95 1.83-1.95 3.77-1.95 4.03 0 4.78 2.55 4.78 5.87v6.58h-4v-5.83c0-1.39-.03-3.18-2-3.18-2 0-2.3 1.5-2.3 3.08v5.93h-4v-11Z",
  github:
    "M12 2a10 10 0 0 0-3.16 19.49c.5.09.68-.22.68-.48v-1.86c-2.78.6-3.37-1.2-3.37-1.2-.46-1.15-1.11-1.46-1.11-1.46-.9-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.9 1.52 2.34 1.08 2.91.83.09-.65.35-1.08.63-1.33-2.22-.25-4.56-1.11-4.56-4.93 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02a9.6 9.6 0 0 1 5 0c1.91-1.3 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.83-2.34 4.68-4.57 4.92.36.31.68.92.68 1.85v2.75c0 .26.18.58.69.48A10 10 0 0 0 12 2Z",
  download:
    "M12 3v12m0 0 4.5-4.5M12 15 7.5 10.5M4 17.5V20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2.5",
  arrowRight: "M4 12h15m0 0-6-6m6 6-6 6",
  arrowUpRight: "M6 18 18 6m0 0h-8m8 0v8",
  external: "M14 4h6v6m0-6L10 14M9 5H5a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-4",
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M6 6l12 12M18 6 6 18",
  check: "M20 6 9 17l-5-5",
  sun: "M7 12a5 5 0 1 0 10 0 5 5 0 1 0-10 0M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42",
  moon: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z",
};

function Icon({ name, size = 18, strokeWidth = 1.8, className, style }) {
  const d = paths[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export default Icon;
